module.exports = __webpack_public_path__ + "static/img/warn.3384de50.png";